import {
  Component,
  computed,
  inject,
  OnInit,
  signal,
  Signal,
  TemplateRef,
  viewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { DataTableComponent } from '@shared/components/data-table/data-table.component';
import {
  DataTableActionsLocation,
  DataTableConfiguration,
  DataTableDataType,
  DataTableSelectionType,
} from '@shared/components/data-table/data-table.types';
import { UserDisplayComponent } from '@shared/components/user-display/user-display.component';
import { PricingPartnerService } from '../../../services/pricing-partner.service';
import { PricingPartnerState } from '../../../store/pricing-partner.state';
import { BundlePrice, PricingPartner } from '../../../types/pricing.types';

@Component({
  selector: 'app-price-history-dialog',
  imports: [DataTableComponent, TranslatePipe, UserDisplayComponent],
  templateUrl: './price-history-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './price-history-dialog.component.scss',
})
export class PriceHistoryDialogComponent implements OnInit {
  protected modalRef = inject(NgbActiveModal);
  private store = inject(Store);
  private pricingPartnerService = inject(PricingPartnerService);

  public bundle = signal<BundlePrice>(null);
  public partnerId = signal<string>(null);

  protected pricingPartner: Signal<PricingPartner>;

  protected dataTableConfiguration: DataTableConfiguration;

  private priceColumnTemplate = viewChild<TemplateRef<any>>(
    'priceColumnTemplate'
  );

  private generatedByColumnTemplate = viewChild<TemplateRef<any>>(
    'generatedByColumnTemplate'
  );

  ngOnInit(): void {
    this.pricingPartner = computed(() =>
      this.store.selectSignal(PricingPartnerState.getPricingPartnerById)()(
        this.partnerId()
      )
    );

    this.dataTableConfiguration = {
      title: '',
      selectionMode: DataTableSelectionType.NONE,
      tableHeadClasses: '',
      actionsLocation: DataTableActionsLocation.RIGHT,
      singleActions: [],
      columns: [
        {
          label: 'pricing.partner.details.columns.price',
          propertyTemplate: this.priceColumnTemplate(),
        },
        {
          label: 'pricing.partner.details.columns.validFrom',
          property: 'validFrom',
          type: DataTableDataType.DATE,
        },
        {
          label: 'pricing.partner.details.columns.generatedBy',
          propertyTemplate: this.generatedByColumnTemplate(),
        },
      ],
      rows$: this.pricingPartnerService.getPricingPartnerBundlePriceHistory(
        this.partnerId(),
        this.bundle().id
      ),
    };
  }
}
